module.exports = __webpack_public_path__ + "static/media/ss-hololens.c4005ddd.png";